(function(){
  function banners(){
    document.querySelectorAll('[data-os-banner]').forEach(function(b){
      if(b._i) return; b._i=1;
      var tr=b.querySelector('.os-btrack'), n=tr.children.length, dots=b.querySelector('.os-dots'), i=0, t;
      if(n<2) return;
      for(var k=0;k<n;k++){var d=document.createElement('button');d.type='button';d.setAttribute('aria-label','Banner '+(k+1));(function(k){d.onclick=function(){go(k);restart();};})(k);dots.appendChild(d);}
      function go(k){i=(k+n)%n;tr.style.transform='translateX(-'+(i*100)+'%)';dots.querySelectorAll('button').forEach(function(x,j){x.classList.toggle('on',j===i)});}
      var ms=(parseFloat(b.getAttribute('data-os-banner'))||4.5)*1000;
      function restart(){clearInterval(t);if(!matchMedia('(prefers-reduced-motion:reduce)').matches)t=setInterval(function(){go(i+1)},ms);}
      b.addEventListener('mouseenter',function(){clearInterval(t)});b.addEventListener('mouseleave',restart);
      go(0);restart();
    });
  }
  function arrows(){
    document.querySelectorAll('[data-os-arrows]').forEach(function(a){
      if(a._i) return; a._i=1;
      var tr=document.getElementById(a.getAttribute('data-os-arrows')); if(!tr) return;
      a.querySelectorAll('button').forEach(function(btn){btn.onclick=function(){tr.scrollBy({left:(btn.dataset.dir==='prev'?-1:1)*tr.clientWidth*.8,behavior:'smooth'})}});
    });
  }
  function marquees(){
    // tendencias: misma velocidad (px/seg) que la barra de promos
    var promo=document.querySelector('.os-mtrack'), pxs=40;
    if(promo){var d=parseFloat(getComputedStyle(promo).animationDuration)||30; pxs=(promo.scrollWidth/2)/d;}
    document.querySelectorAll('.os-ttrack').forEach(function(t){ if(pxs>0) t.style.setProperty('--dur',((t.scrollWidth/2)/pxs)+'s'); });
    document.querySelectorAll('.os-tmq').forEach(function(m){ if(m._i) return; m._i=1;
      m.addEventListener('touchstart',function(){m.classList.add('hold')},{passive:true});
      m.addEventListener('touchend',function(){setTimeout(function(){m.classList.remove('hold')},1200)});});
  }
  function init(){banners();arrows();marquees();}
  if(document.readyState!=='loading') init(); else document.addEventListener('DOMContentLoaded',init);
  window.addEventListener('load',marquees);
  document.addEventListener('shopify:section:load',init);
})();
